'use client';

/**
 * Wishlist locale (localStorage) per esperienze.
 * No DB, no auth — pre-MVP. Una volta che esiste tabella DB user_favorites
 * possiamo migrare i preferiti al server.
 */

import { useCallback, useEffect, useState } from 'react';

const KEY = 'esperienze-wishlist-v1';

function read(): Set<string> {
  if (typeof window === 'undefined') return new Set();
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr : []);
  } catch {
    return new Set();
  }
}

function write(s: Set<string>) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(KEY, JSON.stringify([...s]));
  } catch { /* quota / private mode */ }
}

export function useExperienceWishlist() {
  const [ids, setIds] = useState<Set<string>>(() => new Set());

  useEffect(() => { setIds(read()); }, []);

  const toggle = useCallback((id: string) => {
    setIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      write(next);
      return next;
    });
  }, []);

  const has = useCallback((id: string) => ids.has(id), [ids]);

  return { ids, has, toggle, count: ids.size };
}
